/**
 * Helper for animating elements when they enter the viewport.
 * Usage:
 *   1. Add the 'js-animate-on-view' class to any element you want to animate.
 *   2. The corresponding SCSS mixin will handle the transition when 'animate-on-view.in-view' is added.
 *   3. Import and call animateOnView.init() once on page load.
 */

const animateOnView = {
  init: (selector: string = '.js-animate-on-view') => {
    const elements = document.querySelectorAll<HTMLElement>(selector);

    if (!('IntersectionObserver' in window)) {
      // Fallback: add 'in-view' immediately if IntersectionObserver is not supported
      elements.forEach(el => el.classList.add('in-view'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1 // Adjust as needed
    });

    elements.forEach(el => observer.observe(el));
  }
};

export default animateOnView;

// Example usage:
// import animateOnView from './animate-on-view';
// animateOnView.init(); // Call this after DOM is loaded
// Optionally, you can pass a different selector if needed
